/** Template to get final data-testid for viewer for inlined component or for grid cell, etc */
export const ViewerTestIdTemplate = "{0}-viewer";
/** Template to get final data-testid for editor for inlined component or for grid cell, etc */
export const EditorTestIdTemplate = "{0}-editor";
